import {
  HigherEducationInstitutionType
} from '../../../higher-education-institution-types/higher-education-institution-type/higher-education-institution-type';

export class StudyTerm {
  higherEducationInstitutionType: HigherEducationInstitutionType;
  id: string;
  name: string;
}
